import { getSellerSubmissionPublicFieldLabels } from "../../../utils/sellerIntake/sellerIntakeDefaults";
import { SELLER_INTAKE_FORM_COPY_ES } from "./sellerIntakeFormConstants";
import { SellerFieldError, sellerFieldDescribedBy, sellerFieldInvalid, sellerIntakeFieldFocusHandler } from "./sellerIntakeFormFieldUtils";
import { useSellerIntakeCopy } from "../../../intl/productFormCopy.js";
import SellerPhotoUploadField from "./SellerPhotoUploadField";

const labels = getSellerSubmissionPublicFieldLabels();

/**
 * @param {{
 *   input: import('../../../utils/sellerIntake/sellerIntakeTypes').SellerSubmissionInput,
 *   onChange: (patch: Partial<import('../../../utils/sellerIntake/sellerIntakeTypes').SellerSubmissionInput>) => void,
 *   onPhotosChange?: (photos: import('../../../utils/sellerIntake/sellerPhotoValidation').SellerPhotoPreviewEntry[]) => void,
 *   selectedPhotos?: import('../../../utils/sellerIntake/sellerPhotoValidation').SellerPhotoPreviewEntry[],
 *   errors?: Record<string, string|null|undefined>,
 *   disabled?: boolean,
 * }} props
 */
export default function SellerConditionFields({
  input,
  onChange,
  onPhotosChange,
  selectedPhotos = [],
  errors = {},
  disabled = false,
}) {
  const copy = useSellerIntakeCopy();
  return (
    <fieldset className="sell-car-form__section-card" disabled={disabled}>
      <legend className="sell-car-form__section-title">{copy.conditionSectionTitle}</legend>

      <div className="sell-car-form__stack">
        <div className="sell-car-form__field sell-car-form__field--full">
          <label htmlFor="seller-intake-condition">{labels.conditionSummary}</label>
          <textarea
            id="seller-intake-condition"
            name="conditionSummary"
            rows={3}
            enterKeyHint="next"
            placeholder={SELLER_INTAKE_FORM_COPY_ES.conditionPlaceholder}
            value={input.conditionSummary}
            aria-invalid={sellerFieldInvalid("conditionSummary", errors)}
            aria-describedby={sellerFieldDescribedBy("conditionSummary", errors)}
            onChange={(event) => onChange({ conditionSummary: event.target.value })}
            onFocus={sellerIntakeFieldFocusHandler}
          />
          <SellerFieldError fieldKey="conditionSummary" message={errors.conditionSummary} />
        </div>

        <div className="sell-car-form__field sell-car-form__field--full">
          <label htmlFor="seller-intake-notes">{labels.notes}</label>
          <textarea
            id="seller-intake-notes"
            name="notes"
            rows={3}
            enterKeyHint="done"
            placeholder={SELLER_INTAKE_FORM_COPY_ES.notesPlaceholder}
            value={input.notes}
            aria-invalid={sellerFieldInvalid("notes", errors)}
            aria-describedby={sellerFieldDescribedBy("notes", errors)}
            onChange={(event) => onChange({ notes: event.target.value })}
            onFocus={sellerIntakeFieldFocusHandler}
          />
          <SellerFieldError fieldKey="notes" message={errors.notes} />
        </div>

        <SellerPhotoUploadField
          selectedPhotos={selectedPhotos}
          onChange={onPhotosChange}
          disabled={disabled}
          errors={errors}
        />
      </div>
    </fieldset>
  );
}
